import { Colors } from "../../../../util/colors";
import "../../../../styles/css/pg-product.css";

function QtyPlysMinus({
  Qty,
  PlusPress = () => { },
  MinusPress = () => { },
  disabled,
}) {
  return (
    <div
      style={{
        justifyContent: "center", 
        padding: 10,
      }}
    >
      <div className="pgProductQty" style={{ cursor: "pointer" }}>
        <button onClick={() => MinusPress()} disabled={disabled}>
          <i
            style={{ color: Colors.DarkGreyScale }}
            className="bi bi-dash-square-fill"
          ></i>
        </button>
        <p>{Qty}</p>
        <button onClick={() => PlusPress()} disabled={disabled}>
          <i
            style={{ color: Colors.DarkGreyScale }}
            className="bi bi-plus-square-fill"
          ></i>
        </button>
      </div>
    </div>
  );
}

export default QtyPlysMinus;